export const FETCH_STUDY_PLAN = "FETCH_STUDY_PLAN";
export const INSERT_STUDY_PLAN_ITEM = "INSERT_STUDY_PLAN_ITEM";

export const DELETE_STUDY_PLAN_ITEM = "DELETE_STUDY_PLAN_ITEM";

export const EDIT_STUDY_PLAN_INFO = "EDIT_STUDY_WORK_INFO";
